import axios from 'axios';
import { toast } from 'react-toastify';
//
import { appConfig } from './config';

axios.defaults.timeout = 30000;
axios.interceptors.response.use(
	(res) => {
		if (res?.data.resultCode === -3) {
			localStorage.removeItem('token');
			localStorage.removeItem('token-expired-time');
			localStorage.removeItem('_account');
			// check to reload after 2min
			const reloadTime = localStorage.getItem('token-reload-time');
			const reloadRequire = !reloadTime || Date.now() >= Number(reloadTime);

			if (reloadRequire) {
				localStorage.setItem('token-reload-time', Date.now() + 1000 * 60);
				window.location.replace('/');
			} else {
				appConfig.isDevelopment && console.log('invalid token-reload-time');
			}
		}

		return res;
	},
	(err) => {
		return Promise.reject(err);
	},
);

const defaultHeader = () => ({
	'Content-Type': 'application/json',
	Authorization: localStorage.getItem('token') ? `Bearer ${JSON.parse(localStorage.getItem('token'))}` : null,
});

export class HTTPService {
	static POST = async (path = '', body = {}, header = {}, version = 'v1') => {
		const headers = { ...defaultHeader('POST'), ...header };
		const url = `${appConfig.apiBaseUrl.replace('_version_', version)}/${path}`;

		const data = await axios
			.post(url, body, { headers })
			.then(({ data }) => data)
			.catch(() => false);

		if (appConfig.isDevelopment) console.log({ url, body, headers, method: 'POST', RES: data });

		return data;
	};

	static GET = async (path = '', query = {}, header = {}, version = 'v1') => {
		const headers = { ...defaultHeader('GET'), ...header };

		const queryArray = [];
		Object.keys(query).map((key) => query[key] && queryArray.push(`${key}=${query[key]}`));
		const queryString = queryArray.length > 0 ? `?${queryArray.join('&')}` : '';
		const url = `${appConfig.apiBaseUrl.replace('_version_', version)}/${path}${queryString}`;

		const data = await axios
			.get(url, { headers })
			.then(({ data }) => data)
			.catch(() => false);

		if (appConfig.isDevelopment) console.log({ url, query, headers, method: 'GET', RES: data });

		return data;
	};

	static DELETE = async (path = '', query = {}, header = {}, version = 'v1') => {
		const headers = { ...defaultHeader('DELETE'), ...header };

		const queryArray = [];
		Object.keys(query).map((key) => query[key] && queryArray.push(`${key}=${query[key]}`));
		const queryString = queryArray.length > 0 ? `?${queryArray.join('&')}` : '';
		const url = `${appConfig.apiBaseUrl.replace('_version_', version)}/${path}${queryString}`;

		const data = await axios
			.delete(url, { headers })
			.then(({ data }) => data)
			.catch(() => false);

		if (appConfig.isDevelopment) console.log({ url, query, headers, method: 'DELETE', RES: data });

		return data;
	};

	static PUT = async (path = '', query = {}, header = {}, version = 'v1') => {
		const headers = { ...defaultHeader('PUT'), ...header };

		const queryArray = [];
		Object.keys(query).map((key) => query[key] && queryArray.push(`${key}=${query[key]}`));
		const queryString = queryArray.length > 0 ? `?${queryArray.join('&')}` : '';
		const url = `${appConfig.apiBaseUrl.replace('_version_', version)}/${path}${queryString}`;

		const data = await axios
			.put(url, { headers })
			.then(({ data }) => data)
			.catch(() => false);

		if (appConfig.isDevelopment) console.log({ url, query, headers, method: 'PUT', RES: data });

		return data;
	};

	static handler = async ({
		service = null,
		// status
		onStatus = null,
		// state
		onOK = null,
		onFail = null,
		// message
		showFailMessage = true,
		failMessage = '' /* default: server Message */,
		showOkMessage = false,
		okMessage = '' /* default: server Message */,
	}) => {
		if (!service) return;
		if (onStatus) onStatus('loading');
		let data = await service();

		if (!data) {
			if (onStatus) onStatus('fail');
			if (showFailMessage) toast.error('مشکلی پیش آمده');
			return;
		}

		if (data.resultCode === 1) {
			if (onStatus) onStatus('ok');
			if (okMessage || showOkMessage) toast.success(okMessage || data.resultMessage);
			if (onOK) onOK(data);
		}
		//
		else {
			if (onStatus) onStatus('fail');
			if (failMessage || showFailMessage) toast.error(failMessage || data?.resultMessage);
			if (onFail) onFail(data);
		}
	};

	static generatePath = (path = '', ...params) => {
		let result = path;
		params.map((param) => {
			if (param) result += `/${param}`;
			return null;
		});
		return result;
	};
}

export default HTTPService;
